import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57592588"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "containe" }
const _hoisted_2 = { class: "login-form" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Open Schedule", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_5 = { class: "error" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "username" }, "Usuário", -1))
const _hoisted_8 = { class: "error" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "password" }, "Senha", -1))
const _hoisted_11 = { class: "error" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "remember-me" }, "Lembrar-me", -1))
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  key: 0,
  class: "loader"
}
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "sso-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GoogleLogin = _resolveComponent("GoogleLogin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.messages.error.both), 1),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _withDirectives(_createElementVNode("input", {
          ref: "username",
          type: "text",
          onKeyup: _cache[0] || (_cache[0] = _withKeys(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["enter"])),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.username) = $event)),
          autofocus: "",
          placeholder: "username",
          name: "username",
          id: "username"
        }, null, 544), [
          [_vModelText, _ctx.form.username]
        ]),
        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.messages.error.username), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _withDirectives(_createElementVNode("input", {
          ref: "password",
          type: "password",
          onKeyup: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["enter"])),
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.password) = $event)),
          placeholder: "●●●●●●●●●",
          name: "password",
          id: "password"
        }, null, 544), [
          [_vModelText, _ctx.form.password]
        ]),
        _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.messages.error.password), 1)
      ]),
      _hoisted_12,
      _withDirectives(_createElementVNode("input", {
        type: "checkbox",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.remember_me) = $event)),
        name: "remember-me",
        id: "remember-me"
      }, null, 512), [
        [_vModelCheckbox, _ctx.form.remember_me]
      ]),
      _hoisted_13,
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("button", {
          id: "btnSubmit",
          ref: "btnSubmit",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.submit())),
          disabled: !_ctx.form.password || !_ctx.form.username,
          class: _normalizeClass({ isSubmited: _ctx.loading })
        }, [
          _createVNode(_Transition, {
            name: "fade",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16))
                : (_openBlock(), _createElementBlock("span", _hoisted_17, "Entrar"))
            ]),
            _: 1
          })
        ], 10, _hoisted_15)
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_GoogleLogin, {
          callback: _ctx.callback,
          prompt: ""
        }, null, 8, ["callback"])
      ])
    ])
  ]))
}